
import get from 'lodash/get';

export const getImmersiveTour = (listing) => {
  return get(listing, 'virtualTour', null);
};

export const getTitle = (listing) => {
  if (listing.id) {
    return listing.year + ' ' + listing.make + ' ' + get(listing, 'model', '');
  }
  return '';
};
